const validRequest = value => value && typeof value.uid === 'string' && value.uid.length > 0
  && typeof value.amount === 'number' && Number.isFinite(value.amount) && value.amount > 0
  && ['credit', 'debit'].includes(value.operation)
  && typeof value.reason === 'string' && value.reason.trim().length > 2
  && value.reason.trim().length <= 240
  && typeof value.idempotencyKey === 'string' && value.idempotencyKey.length > 0;

// Keep an uncertain operation across a reload. A retry must never change either
// its identity or its financial fields, even if the form has since changed.
function createWalletAdjustmentRequest(storage, actorUid, createKey = () => `admin-adjust-${window.crypto.randomUUID()}`, decimal = 2) {
  if (!actorUid) throw new Error('Yönetici oturumu bulunamadı.');
  const key = `wallet-adjustment:${actorUid}`;
  let pending = null;
  try {
    const saved = storage.getItem(key);
    if (saved) {
      pending = JSON.parse(saved);
      if (!validRequest(pending)) throw new Error('invalid request');
    }
  } catch (_) {
    throw new Error('Bekleyen cüzdan işlemi okunamadı. Yeni işlem göndermeden işlem geçmişini kontrol edin.');
  }
  let busy = false;
  const clearOwnRequest = () => {
    const saved = storage.getItem(key);
    if (saved && JSON.parse(saved).idempotencyKey === pending.idempotencyKey) storage.removeItem(key);
    pending = null;
  };
  return {
    pending: () => pending && { ...pending },
    isBusy: () => busy,
    async execute(draft, submit) {
      if (busy) throw new Error('İşlem devam ediyor.');
      busy = true;
      try {
        if (!pending) {
          const saved = storage.getItem(key);
          if (saved) {
            const restored = JSON.parse(saved);
            if (!validRequest(restored)) throw new Error('Bekleyen işlem bilgileri geçersiz.');
            pending = restored;
          }
        }
        if (!pending) {
          const request = {
            uid: draft.uid, amount: draft.amount, operation: draft.operation,
            reason: draft.reason, idempotencyKey: createKey(),
          };
          if (!validRequest(request)) throw new Error('İşlem bilgileri geçersiz.');
          if (!Number.isInteger(decimal) || decimal < 0 || decimal > 6) throw new Error('Para birimi hassasiyeti doğrulanamadı.');
          const text = String(request.amount);
          const [whole, fraction = ''] = text.split('.');
          const minor = Number(whole) * (10 ** decimal) + Number((fraction + '0'.repeat(decimal)).slice(0, decimal));
          if (!/^\d+(?:\.\d+)?$/.test(text) || /[1-9]/.test(fraction.slice(decimal)) || !Number.isSafeInteger(minor) || minor <= 0) {
            throw new Error(`Tutar en fazla ${decimal} ondalık basamak içermeli ve güvenli işlem sınırında olmalıdır.`);
          }
          storage.setItem(key, JSON.stringify(request));
          pending = request;
        }
        let result;
        try {
          result = await submit({ ...pending });
        } catch (error) {
          // These exact 400 errors are checked by the endpoint before it calls
          // the ledger. Auth changes, conflicts and transport failures are NOT
          // evidence that an earlier attempt did not move money.
          if (error.status === 400 && ['invalid-uid', 'invalid-reason', 'invalid-idempotency-key'].includes(error.code)) {
            clearOwnRequest();
          }
          throw error;
        }
        if (result?.success !== true || typeof result.walletBalance !== 'number' || !Number.isFinite(result.walletBalance)) {
          throw new Error(result?.error || 'İşlemin sonucu doğrulanamadı. Aynı işlemi güvenle tekrar sorgulayabilirsiniz.');
        }
        clearOwnRequest();
        return result;
      } finally {
        busy = false;
      }
    },
  };
}

module.exports = { createWalletAdjustmentRequest };
